
<form
  #assessmentForm="ngForm"
  (ngSubmit)="onSubmit()">



  <h2>{{ assessmentObject?.entityType | titlecase }} &nbsp; Assessment</h2>


  <mat-grid-list cols="12" rowHeight="50px" style="overflow: visible;">



    <mat-grid-tile
      [colspan]=8
      [rowspan]=2>
      <mat-form-field>
        <input
          matInput
          required
          placeholder="Name"
          [(ngModel)]="assessmentObject.name"
          name="name">
      </mat-form-field>
    </mat-grid-tile>


    <mat-grid-tile
      [colspan]=4
      [rowspan]=2>
      <mat-form-field>
        <mat-select placeholder="Type"
          [disabled]="typeReadOnly"
          (openedChange)="assessmentTypeSelectionChanged()"
          [(ngModel)]="assessmentObject.type"
          name="type">
          <!-- @for (type of assessmentTypes; track type) {
            <mat-option
              [value]="type">
              {{ type }}
            </mat-option>
          } -->
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>






    <mat-grid-tile
      [colspan]=4
      [rowspan]=1>
      <h4>Owner</h4>
    </mat-grid-tile>

    <mat-grid-tile
      [colspan]=4
      [rowspan]=1>
      <h4>Assessor</h4>
    </mat-grid-tile>

    <mat-grid-tile
      [colspan]=4
      [rowspan]=1>
      <h4>Final Reviewer</h4>
    </mat-grid-tile>


    <mat-grid-tile
      [colspan]=4
      [rowspan]=2>

      <p-autoComplete class="autocomplete-label" [(ngModel)]="assessmentObject.owner"
        appendTo="body" name="owner" field="friendlyName" [suggestions]="filteredUsers"
        (completeMethod)="filterUsers($event)"  [minLength]="1"
        placeholder="type Last Name of user" [dropdown]="true">
        <ng-template let-element pTemplate="item">
          <span style="font-size:18px;font-weight: bold;">
            {{element.friendlyName}}
          </span>
        </ng-template>
      </p-autoComplete>

    </mat-grid-tile>



    <mat-grid-tile
      [colspan]=4
      [rowspan]=2>


      <p-autoComplete class="autocomplete-label" [(ngModel)]="assessmentObject.assessor"
        appendTo="body" name="assessor" field="friendlyName" [suggestions]="filteredUsers"
        (completeMethod)="filterUsers($event)" [minLength]="1"
        placeholder="type Last Name of user" [dropdown]="true">
        <ng-template let-element pTemplate="item">
          <span style="font-size:18px;font-weight: bold;">
            {{element.friendlyName}}
          </span>
        </ng-template>
      </p-autoComplete>

    </mat-grid-tile>


    <mat-grid-tile
      [colspan]=4
      [rowspan]=2>


      <p-autoComplete class="autocomplete-label" [(ngModel)]="assessmentObject.finalReviewer"
        appendTo="body" name="finalReviewer" field="friendlyName" [suggestions]="filteredUsers"
        (completeMethod)="filterUsers($event)"  [minLength]="1"
        placeholder="type Last Name of user" [dropdown]="true">
        <ng-template let-element pTemplate="item">
          <span style="font-size:18px;font-weight: bold;">
            {{element.friendlyName}}
          </span>
        </ng-template>
      </p-autoComplete>


    </mat-grid-tile>



    <mat-grid-tile
      [colspan]=4
      [rowspan]=2>

      <mat-form-field class="input-wide-width">

        <input
          matInput
          [matDatepicker]="criticalDatePicker"
          placeholder="Critical Date"
          [(ngModel)]="assessmentObject.criticalDate"
          name="criticalDate">

        <mat-datepicker-toggle
          matSuffix
          [for]="criticalDatePicker">
        </mat-datepicker-toggle>

        <mat-datepicker
          #criticalDatePicker>
        </mat-datepicker>
      </mat-form-field>
    </mat-grid-tile>



    <mat-grid-tile
      [colspan]=4
      [rowspan]=2>

      <mat-form-field class="input-wide-width">

        <input
          readonly="true"
          matInput
          placeholder="Source Record"
          [(ngModel)]="assessmentObject.sourceRecord"
          name="contractId">

      </mat-form-field>
    </mat-grid-tile>



    <mat-grid-tile
      [colspan]=4
      [rowspan]=2>

      Vendor/Party: &nbsp; &nbsp; <br><br>
      <b>{{ partyFriendlyName }}</b>

    </mat-grid-tile>




    <mat-grid-tile
      [colspan]=4
      [rowspan]=2>
      <mat-form-field>
        <mat-select
          placeholder="Status"
          (selectionChange)="assessmentStatusSelectionChanged()"
          [(ngModel)]="assessmentObject.status"
          name="status">
          <!-- @for (status of assessmentStatuses; track status) {
            <mat-option
              [value]="status">
              {{ status }}
            </mat-option>
          } -->
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>


    <!-- [disabled]="assessmentForm.invalid || statusUnchanged" -->
    <mat-grid-tile
      [colspan]=2
      [rowspan]=2>

      @if (!waiting) {
        <button
          [disabled]="assessmentForm.invalid"
          mat-raised-button color="primary"
          type="button"
          (click)="saveAndSend()"
          class="left-align">
          Save
        </button>
      }

    </mat-grid-tile>

    <mat-grid-tile
      [colspan]=2
      [rowspan]=2>

      @if (!waiting) {
        <button
          mat-raised-button color="primary"
          type="button"
          (click)="cancelDialog()"
          class="left-align">
          Cancel
        </button>
      }

    </mat-grid-tile>


    <mat-grid-tile
      [colspan]=2
      [rowspan]=2>

      <button
        mat-raised-button color="primary"
        type="button"
        (click)="printAssessment()"
        class="left-align">
        Print
      </button>

    </mat-grid-tile>


    <mat-grid-tile
      [colspan]=8
      [rowspan]=2>
      <mat-form-field>
        <input
          matInput
          placeholder="Quality Metrics Contract Location"
          [(ngModel)]="assessmentObject.qualityMetricsLocation"
          name="qualityMetricsLocation">
      </mat-form-field>
    </mat-grid-tile>


    <mat-grid-tile
      [colspan]=4
      [rowspan]=2>

    </mat-grid-tile>


  </mat-grid-list>


  <br>

    <h3>Quality Metrics Contract Language Excerpt</h3>

    <p-editor
      [(ngModel)]="assessmentObject.qualityMetricsLanguageExcerpt"
      name="qualityMetricsLanguageExcerpt"
      [style]="{'height':'250px', 'width':'1200px'}">
      <p-header>
        <span class="ql-formats">
          <button class="ql-bold" aria-label="Bold"></button>
          <button class="ql-italic" aria-label="Italic"></button>
          <button class="ql-underline" aria-label="Underline"></button>
        </span>
      </p-header>
    </p-editor>


    <br>
      <br>
        <br>


          @if (waiting) {
            <mat-spinner
              >
            </mat-spinner>
          }



          <mat-accordion>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Evaluation Instructions
                </mat-panel-title>
                <mat-panel-description>
                  Open to see instructions on how to do assessments
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div [innerHTML]="assessmentInstructions"></div>

            </mat-expansion-panel>
          </mat-accordion>


          @if (scores && assessmentObject.questionsAndAnswers) {
            <div>
              @for (questionAnswerObject of assessmentObject?.questionsAndAnswers; track questionAnswerObject; let i = $index) {
                <mat-card appearance="outlined" class="questions-card"
                  >
                  <mat-card-header>
                    <mat-card-title>{{questionAnswerObject.question}}</mat-card-title>
                  </mat-card-header>
                  @if (scores) {
                    <mat-card-content>
                      <mat-form-field style="width: 250px;">
                        <mat-label>Choose a score</mat-label>
                        <mat-select
                          [(value)]="assessmentObject.questionsAndAnswers[i].score"
                          (selectionChange)="onScoreChange($event.value, i)">
                          @for (option of scores; track option; let index = $index) {
                            <mat-option [value]="index">
                              {{ option }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <br>
                        <br>
                        </mat-card-content>
                      }
                      <mat-card-actions>
                        <mat-form-field class="example-full-width">
                          <mat-label>Comment</mat-label>
                          <textarea matInput
                            [disabled]="readOnly"
                            placeholder="Your comment" name="commenttextarea_{{i}}"
                          [(ngModel)]="assessmentObject.questionsAndAnswers[i].comment"></textarea>
                        </mat-form-field>
                      </mat-card-actions>
                    </mat-card>
                  }
                </div>
              }

              <mat-divider></mat-divider>

              <br>
                <br>
                  <b>Total Score: </b> &nbsp; &nbsp; <b>{{ totalScore }}</b>
                  <br>
                    <br>

                      <h3>Recommendations</h3>

                      <p-editor
                        [(ngModel)]="assessmentObject.recommendation"
                        name="recommendation"
                        [style]="{'height':'250px', 'width':'1200px'}">
                        <p-header>
                          <span class="ql-formats">
                            <button class="ql-bold" aria-label="Bold"></button>
                            <button class="ql-italic" aria-label="Italic"></button>
                            <button class="ql-underline" aria-label="Underline"></button>
                          </span>
                        </p-header>
                      </p-editor>


                      <br>
                        <br>



                          <mat-grid-list cols="12" rowHeight="50px">

                            <mat-grid-tile
                              [colspan]=4
                              [rowspan]=2>

                              <mat-form-field class="one-third-width">
                                <mat-select
                                  placeholder="Status"
                                  (selectionChange)="assessmentStatusSelectionChanged()"
                                  [(ngModel)]="assessmentObject.status"
                                  name="status">
                                  @for (status of assessmentStatuses; track status) {
                                    <mat-option
                                      [value]="status">
                                      {{ status }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>

                            </mat-grid-tile>



                            <mat-grid-tile
                              [colspan]=4
                              [rowspan]=2>

                              @if (!waiting) {
                                <button
                                  [disabled]="assessmentForm.invalid"
                                  mat-raised-button color="primary"
                                  type="button"
                                  (click)="saveAndSend()"
                                  class="left-align">
                                  Save
                                </button>
                              }

                            </mat-grid-tile>


                            <mat-grid-tile
                              [colspan]=4
                              [rowspan]=2>

                            </mat-grid-tile>


                          </mat-grid-list>





                          <br>
                            <br>

                              @if (attestation) {
                                <div>
                                  {{ attestation[0] }}
                                </div>
                              }


                              <br>
                                <br>


                                  @if (linkToContractFile) {
                                    <div>
                                      <h3>View Contract</h3>
                                      &nbsp; &nbsp;
                                      <a target="_blank" href="{{linkToContractFile}}">
                                        View Contract
                                      </a>
                                    </div>
                                  }

                                  <!-- <div *ngIf="assessmentObject.entityType === 'party'">
                                  <h3>View Party</h3>
                                  &nbsp; &nbsp;
                                  <a target="_blank" href="environment.linkToDeployment + 'vendor/' + assessmentObject.entityId">
                                    View Party
                                  </a>
                                </div> -->


                                @if (assessmentObject?.entityType === 'contract') {
                                  <div>
                                    <mat-grid-list cols="12" rowHeight="50px">
                                      <mat-grid-tile
                                        [colspan]=4
                                        [rowspan]=1>
                                        Your Sites
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=4
                                        [rowspan]=1>
                                        Status
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=4
                                        [rowspan]=1>
                                        Expiration Date
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=4
                                        [rowspan]=2>
                                        <b>{{ contractObject?.sitesFriendlyName }}</b>
                                        <!-- <b>{{ contractObject?.sites[0].name }}</b> -->
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=4
                                        [rowspan]=1>
                                        <b>{{ contractObject?.status }}</b>
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=4
                                        [rowspan]=1>
                                        <b>{{ contractObject?.expirationDate | date:'shortDate' }}</b>
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=4
                                        [rowspan]=1>
                                        Your Departments
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=4
                                        [rowspan]=1>
                                        Renewal Type
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=4
                                        [rowspan]=1>
                                        Contract Type
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=4
                                        [rowspan]=2>
                                        <b>{{ contractObject?.departments }}</b>
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=4
                                        [rowspan]=1>
                                        <b>{{ contractObject?.renewalType }}</b>
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=4
                                        [rowspan]=1>
                                        <b>{{ contractObject?.contractType }}</b>
                                      </mat-grid-tile>
                                    </mat-grid-list>
                                  </div>
                                }

                                <br>
                                  <br>



                                    <app-attachment-connections
                                      [(attachmentObjectArray)]="attachmentObjectArray"
                                      attachmentTabOnScreen="true">
                                    </app-attachment-connections>




                                  </form>



                                  @if (printView) {
                                    <div id="print-section">
                                      <b>Assessment Name:</b> &nbsp; &nbsp; {{assessmentObject?.name}}
                                      <br>
                                        <br>
                                          <b>Status:</b> &nbsp; &nbsp; {{ assessmentObject?.status }}
                                          <br>
                                            <br>
                                              <b>Source Record:</b> &nbsp; &nbsp; {{ assessmentObject?.sourceRecord }}
                                              <br>
                                                <br>
                                                  <b>Party/Vendor:</b> &nbsp; &nbsp; {{ partyFriendlyName }}
                                                  <br>
                                                    <br>
                                                      <b>Owner:</b> &nbsp; &nbsp; {{ ownerFriendlyName }}
                                                      <br>
                                                        <b>Assessor:</b> &nbsp; &nbsp; {{ assessorFriendlyName }}
                                                        <br>
                                                          <b>Final Reviewer:</b> &nbsp; &nbsp; {{ finalReviewerFriendlyName }}
                                                          <br>
                                                            <br>
                                                              <b>Recommendations/Detailed Action Plan:</b> &nbsp; &nbsp;
                                                              <div [innerHTML]="assessmentObject.recommendation"></div>
                                                              <br>
                                                                <br>
                                                                  Total Score: &nbsp; &nbsp; {{ assessmentObject?.totalScore }}
                                                                  <br>
                                                                    @for (question of questions; track question; let i = $index) {
                                                                      <mat-card appearance="outlined" class="questions-card"
                                                                        >
                                                                        <mat-card-header>
                                                                          <mat-card-title><b>{{question}}</b></mat-card-title>
                                                                        </mat-card-header>
                                                                        @if (scores) {
                                                                          <mat-card-content>
                                                                            <!-- <b>Score:</b> &nbsp; &nbsp; {{scores[assessmentObject.questionsAndAnswers[i].score].score }}
                                                                            &nbsp; &nbsp; {{scores[assessmentObject.questionsAndAnswers[i].score].description }}
                                                                            <br> -->
                                                                          </mat-card-content>
                                                                        }
                                                                        <mat-card-actions>
                                                                          <b>Comment:</b> &nbsp; &nbsp; {{ assessmentObject.questionsAndAnswers[i].comment }}
                                                                        </mat-card-actions>
                                                                      </mat-card>
                                                                    }
                                                                    <br>
                                                                      <br>
                                                                        {{ attestation[0] }}
                                                                        <br>
                                                                          <br>
                                                                            <div [innerHTML]="assessmentInstructions"></div>
                                                                          </div>
                                                                        }
                                                                        <!-- END OF PRINT SECTION -->